import { createContext } from 'react';

import { TranslationConfig } from '../types';

const TranslationsContext = createContext<TranslationConfig | undefined>(undefined);

export { TranslationsContext };
